import $ from "jquery";

/**
 * Mouse tracker
 */
// let direction = "",
// 	oldx = 0,
// 	mousemovemethod = function (e) {
// 		if (e.pageX < oldx) {
// 			direction = "left";
// 		} else if (e.pageX > oldx) {
// 			direction = "right";
// 		}
// 		$("body").attr("data-mouse-direction", direction);
// 		oldx = e.pageX;
// 	};

// document.addEventListener("mousemove", mousemovemethod);

/**
 * Handle mousemove
 */
// const { body } = document;
// const fullWidth = $(window).width();
// const fullHeight = $(window).height();

// body.addEventListener("mousemove", coordUpdater);

// body.style.setProperty("--pos-x", "0px");
// body.style.setProperty("--pos-y", "0px");
// body.style.setProperty("--mouse-x", "0%");
// body.style.setProperty("--mouse-y", "0%");
// body.style.setProperty("--rotate-x", "0deg");
// body.style.setProperty("--rotate-y", "0deg");

// let coordIsUpdating = false;
// function coordUpdater(e) {
// 	if (!coordIsUpdating) {
// 		window.requestAnimationFrame(() => {
// 			var xPos = e.clientX / fullWidth;
// 			var yPos = e.clientY / fullHeight;
// 			var x = e.clientX;
// 			var y = e.clientY;

// 			body.style.setProperty("--pos-x", x + "px");
// 			body.style.setProperty("--pos-y", y + "px");
// 			body.style.setProperty("--mouse-x", (xPos * 100).toFixed(2) + "%");
// 			body.style.setProperty("--mouse-y", (yPos * 100).toFixed(2) + "%");
// 			// body.style.setProperty("--mouse-move-x", xPos);
// 			// body.style.setProperty("--mouse-move-y", yPos);
// 			body.style.setProperty("--rotate-x", -90 + 180 * xPos.toFixed(2) + "deg");
// 			body.style.setProperty(
// 				"--rotate-y",
// 				-90 + 180 * yPos.toFixed(2) * -1 + "deg"
// 			);

// 			coordIsUpdating = false;
// 		});

// 		coordIsUpdating = true;
// 	}
// }

/**
 * Track scroll
 */

onscroll = () => {
    handleScroll();
};

function handleScroll() {
    let scroll = $(window).scrollTop();

    // The header sticks via CSS (position: sticky); this class only drives the
    // stuck-state styling (shadow, logo colour) and other scroll-aware parts.
    const scrollTrigger = document.querySelector("[data-scroll-trigger]");
    const scrollTriggerHeight = scrollTrigger ? scrollTrigger.offsetHeight : 0;

    if (scroll > 0 && scroll >= scrollTriggerHeight) {
        // header is stuck (scrollTrigger scrolled away)
        $("body").addClass("s_user-scrolled");

        // Give enough time for the animation to be done
        setTimeout(() => {
            $("body").removeClass("s_show-submenu");
        }, 300);
    } else {
        // at the top
        $("body").removeClass("s_user-scrolled");
    }

    if (
        window.innerHeight + window.scrollY + 600 >=
        document.body.offsetHeight
    ) {
        $("body").addClass("s_user-scrolled-to-footer");

        dispatchEvent(new CustomEvent("user-interaction:scrolled-to-footer"));
    } else {
        $("body").removeClass("s_user-scrolled-to-footer");
    }

    if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        $("body").addClass("s_user-scrolled-to-bottom");
    } else {
        $("body").removeClass("s_user-scrolled-to-bottom");
    }
}

setTimeout(() => {
    handleScroll();
}, 50);

/**
 * Is footer in viewport?
 */
// const footer = document.querySelector("footer");

// // create a new Intersection Observer
// let observer = new IntersectionObserver((entries) => {
// 	let entry = entries[0];

// 	if (entry.isIntersecting) {
// 		dispatchEvent(new CustomEvent("user-interaction:scrolled-to-bottom"));
// 	}
// });

// // start observing footer
// if (footer) {
// 	observer.observe(footer);
// }
